
import languages from "./languages";
import { _handler } from "../classes/index.classes";

const decode = (str) => {return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, '\'').replace(/&#x2F;/g, '/');}

var i18 = null;

var KTLang = function () {

    var initLang = () => {
        // use plugins and options as needed, for options, detail see
        // https://www.i18next.com
        window.i18next
            // detect user language
            // learn more: https://github.com/i18next/i18next-browser-languageDetector
            .use(window.i18nextBrowserLanguageDetector)
            // init i18next
            // for all options read: https://www.i18next.com/overview/configuration-options
            .init({
                //debug: true,
                fallbackLng: 'en',
                resources: languages
            }, (err, t) => {
                if (err) return console.error(err);                

                // define the formatter function
                window.i18next.services.formatter.add('LFull', (value, lng, options) => {
                    //console.log("formating",value, options);
                    if(options.interpolationkey == 'value'){
                        
                        let ret = '';
                        
                        ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("LLLL");                        

                        ret = decode(ret);
                        //console.log(ret);
                        return ret;
                    }
                    
                });
                window.i18next.services.formatter.add('LLLL', (value, lng, options) => {
                    //console.log("formating",value, options);
                    if(options.interpolationkey == 'value'){
                        
                        let ret = '';
                        
                        ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("L");
                        
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'year'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("DD MMM");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'week'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'day'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("h:mm a");
                        }

                        ret = decode(ret);
                        //console.log(ret);
                        return ret;
                    }
                    
                });

                window.i18next.services.formatter.add('LLL', (value, lng, options) => {
                    //console.log("formating LLL",value, options);
                    if(options.interpolationkey == 'value'){
                        let ret = '';

                        //ret = moment.unix(parseInt(options.timestamp)).locale(lng).calendar();
                        ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd LL hh:mm a");

                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'year'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd LL hh:mm a");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'week'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd LL hh:mm a");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'day'))
                        {
                            //ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("h:mm a");
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).calendar();
                        }
                        ret = decode(ret);
                        //console.log(ret);
                        return ret;
                    }
                });

                window.i18next.services.formatter.add('lll', (value, lng, options) => {
                    //console.log("formating LLL",value, options);
                    if(options.interpolationkey == 'value'){
                        let ret = '';

                        //ret = moment.unix(parseInt(options.timestamp)).locale(lng).calendar();
                        ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("MM/DD/YYYY hh:mm A");

                        /*if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'year'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd LL hh:mm a");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'week'))
                        {
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("dddd LL hh:mm a");
                        }
                        if(moment.unix(parseInt(options.timestamp)).isSame(moment(), 'day'))
                        {
                            //ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("h:mm a");
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).calendar();
                        }*/
                        ret = decode(ret);
                        //console.log(ret);
                        return ret;
                    }
                });

                window.i18next.services.formatter.add('ago', (value, lng, options) => {

                    if(options.interpolationkey == 'value'){
                        let ret = '';

                        ret = moment.unix(parseInt(options.timestamp)).locale(lng).fromNow();
                        ret = decode(ret);
                        //console.log(ret);
                        ret = ret.charAt(0).toUpperCase() + ret.slice(1);
                        return ret;
                    }

                });

                window.i18next.services.formatter.add('blog', (value, lng, options) => {
                        
                        if(options.interpolationkey == 'value'){
                            let ret = '';
    
                            ret = moment.unix(parseInt(options.timestamp)).locale(lng).format("MMM D, YYYY");
                            ret = decode(ret);
                            //console.log(ret);
                            ret = ret.charAt(0).toUpperCase() + ret.slice(1);
                            return ret;
                        }
                });

                // for options see
                // https://github.com/i18next/jquery-i18next#initialize-the-plugin
                window.jqueryI18next.init(i18next, $, {
                    useOptionsAttr: true
                });

                i18 = i18next;

                console.log("Init Lang");

                if(localStorage.getItem("i18nextLng").substring(0,2) == "pt")
                {
                    $(".flag-lang").attr("src", "assets/media/flags/br.gif");
                }
                if(localStorage.getItem("i18nextLng").substring(0,2) == "en")
                {
                    $(".flag-lang").attr("src", "assets/media/flags/us.gif");
                }
                if(localStorage.getItem("i18nextLng").substring(0,2) == "es")
                {
                    $(".flag-lang").attr("src", "assets/media/flags/es.gif");
                }
                if(localStorage.getItem("i18nextLng").substring(0,2) == "zh")
                {
                    $(".flag-lang").attr("src", "assets/media/flags/cn.gif");
                }

                // start localizing, details:
                // https://github.com/i18next/jquery-i18next#usage-of-selector-function
                upd();

                
            });
        
        $('body').off('click', '.btn-lang');
        $('body').on('click', '.btn-lang', function() {        
            KTLang.setLang($(this).attr("data-lang"));
            $(".flag-lang").attr("src", "assets/media/flags/"+ $(this).attr("data-flag") +".gif");
            _handler.emit('lang-changed', $(this).attr("data-lang"));
        });
    }

    var upd = () =>{

        if(i18 != null)
        {
            $('body').localize();
            if ($.fn.tooltip) $('[data-toggle="tooltip"]').tooltip();
        }
    }

    var setLang = (lang) => {

        if(i18 != null)
        {
            //console.log("Passsed: ",lang);
            i18.changeLanguage(lang, () => {
                upd();
            });
        }
    }

    var getLang = () => {

        if(i18 != null)
        {
            return window.i18next.language.substring(0,2);
        }
    }
    

    return {
        init: function () {
            initLang();
        },
        setLang: function (lang) {
            setLang(lang);
        },
        update: function(){
            upd();
        },
        getLang: function(){
            return getLang();
        }
    };
}();

export { KTLang }; //para uso interno

// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTLang;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
    //KTLang.init();
    
});
KTLang.init();